'use strict';

customerZone

/**
 * A component that loads paged data into the model.  The component will diplay a 'load more' button
 * as long as there is more data to load (meaning the last loaded chunk contained a paging field and it
 * promised more data).  The component is responsible for populating the array backed by the 'data' field
 * and it will also load the initial chunk.
 *
 * To reset the paging, simply reassign undefined to 'data'.
 *
 * @param loader bind this to a function that accepts a page number and returns a chunk of data.
 * @param data bind this to the array that is to be the target of the data.
 * @param state bind this to inject a boolean that indicates when data is being loaded
 */
.component('pagedLoader', {
    bindings: {
        loader: '<',
        data: '=',
        state: '='
    },
    templateUrl: customerZone.fromBase('components/paged-loader/paged-loader.component.html'),
    controller: ['$q', '$log', 'errorCode', 'utils', function($q, $log, errorCode, utils) {
        var vm = this;

        vm.state = false;

        var loadPage = function(page){
            if (!vm.data) vm.data = [];
            vm.data.reload = reload;
            return vm.loader(page)
                .then(function (r){
                    Array.prototype.push.apply(vm.data, r);
                    vm.data.paging = r.paging;
                }, function (error) {
                    utils.showError();
                });
        };

        vm.loadMore = function () {
            if (vm.state) return;
            vm.state = true;
            if (!vm.data) vm.data = [];
            vm.data.reload = reload;
            var page = (vm.data.paging ? vm.data.paging.next : null) || 1;
            return loadPage(page).then(function(){
                vm.state = false;
            });
        };

        vm.moreAvailable = function () {
            return vm.data && vm.data.paging && vm.data.paging.next;
        };

        vm.$onChanges = function(){
            // if data is externally reset, load the first page again.
            if (!vm.data)
                vm.loadMore();
        };

        var reload = function(){
            vm.data = [];
            vm.data.reload = reload;
            vm.loadMore();
        };

        vm.$onInit = function(){
            vm.loadMore();
        };
    }],
    controllerAs: 'vm'
});
